<template>
  <el-config-provider :locale="zhCn">
    <!-- <MainLayout/> -->
    <component :is="currentLayout"></component>
  </el-config-provider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// import MainLayout from './views/Layout/MainLayout.vue'

const DefaultLayout = defineAsyncComponent(() => import('./views/Layout/MainLayout.vue'));
const AiLayout = defineAsyncComponent(() => import('./views/Layout/AiLayout.vue'));

const route = useRoute();

// 核心判断：仅根据路由是否以/ai/开头切换布局，不修改任何路由配置
const currentLayout = computed(() => {
  // 严格匹配以/ai/开头的路由（比如/ai/dashboard、/ai/model，不含/ai本身）
  return route.path.startsWith('/ai') ? AiLayout : DefaultLayout;
});


</script>